import {
  createPlugin,
  createApiFactory,
  discoveryApiRef,
  fetchApiRef,
} from '@backstage/core-plugin-api';
import { rootRouteRef } from './routes';
import { grafanaQueryApiRef } from './api/GrafanaQueryApi';
import { GrafanaQueryClient } from './api/GrafanaQueryClient';

export const grafanaDashboardPlugin = createPlugin({
  id: 'grafana-dashboard',
  routes: {
    root: rootRouteRef,
  },
  apis: [
    createApiFactory({
      api: grafanaQueryApiRef,
      deps: {
        discoveryApi: discoveryApiRef,
        fetchApi: fetchApiRef,
      },
      factory: ({ discoveryApi, fetchApi }) =>
        new GrafanaQueryClient({ discoveryApi, fetchApi }),
    }),
  ],
});
